<template>
	<div v-if="groupData" class="pt-3">
		<div class="row">
			<div class="col-lg-6">
				<h5>Search and Add Teams</h5>
				<br />
				<div @clickaway="exitTeams" class="col-lg-6">
					<label>Select a team to add it to the group</label>
					<div class="input-and-submit-wrapper form-group">
						<div class="form-icon">
							<i class="fas fa-search"></i>
						</div>
						<input
							type="text"
							:disabled="isProcessing"
							class="has-icon form-control"
							v-model="searchTeamsFilter"
							placeholder="Type Team's Name"
							@input="showFilteredTeams"
						/>
					</div>
					<div
						class="dropdown-content manage-groups-scrollable-filter-results vertical-scroll"
						v-show="teamsShown"
					>
						<div
							v-for="team in filteredTeams"
							:key="team.id"
							@click.prevent="selectTeam(team)"
							class="dropdown-item"
						>
							{{ team.id + ' - ' + team.name }}
						</div>
					</div>
				</div>
				<br />
			</div>
			<div class="col-lg-6">
				<h5>Current Group Teams</h5>
				<br />
				<ul class="list-group pt-4">
					<li
						class="list-group-item list-group-item-secondary d-flex justify-content-between align-items-center"
					>
						<div class="col-10">
							<strong>Team ID - Name</strong>
						</div>
						<div class="col-2">
							<strong>Actions</strong>
						</div>
					</li>
					<li
						v-for="team in groupData.groupTeams"
						:key="team.id"
						class="list-group-item d-flex justify-content-between align-items-center"
					>
						<div class="col-10">
							<span
								>{{ team.team_id }} - <strong>{{ team.team_name }}</strong></span
							>
						</div>
						<div class="col-2">
							<span @mouseenter="hovered = team.id" @mouseleave="hovered = null">
								<button
									class="rounded border-0"
									@click.prevent="deleteGroupTeam(team.team_id)"
									title="Remove from Group"
								>
									<i
										:class="[
											hovered === team.id ? 'fas' : 'far',
											'fa-minus-square',
										]"
									></i>
								</button>
							</span>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<div v-else>
		<div class="loader d-block text-center">
			<p><i class="fas fa-circle-notch fa-spin"></i></p>
			<p>Loading..</p>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		groupData: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			searchTeamsFilter: '',
			teamsShown: false,
			isProcessing: false,
			hovered: null,
		};
	},
	computed: {
		filteredTeams() {
			return this.groupData.teamsToAdd.filter((team) =>
				team.name.toLowerCase().includes(this.searchTeamsFilter.toLowerCase()),
			);
		},
	},
	methods: {
		async addTeamToGroup(teamId) {
			const groupId = this.groupData.groupInfo.id;
			const data = {
				teamId: teamId,
			};
			try {
				const response = await axios.post(`/api/groups/${groupId}/team`, data);
				swal('Added!', 'Team has been successfully added to the group.', 'success');
			} catch (error) {
				console.error('There was an error adding the team to the group', error.response);
				swal('Failed!', 'There was an error adding the team to the group.', 'error');
			}
			this.$emit('update-triggered', true);
		},
		async deleteGroupTeam(teamId) {
			const groupId = this.groupData.groupInfo.id;
			try {
				const response = await axios.delete(`/api/groups/${groupId}/team`, {
					params: { teamId },
				});
				swal('Removed!', 'Team has been successfully removed from the group.', 'success');
			} catch (error) {
				console.error('There was an error removing the team from the group', error);
				swal('Failed!', 'There was an error removing the team from the group.', 'error');
			}
			this.$emit('update-triggered', true);
		},
		showFilteredTeams() {
			this.teamsShown = true;
		},
		selectTeam(team) {
			this.groupData.groupTeams.push(team);
			this.searchTeamsFilter = '';
			this.teamsShown = false;
			this.addTeamToGroup(team.id);
		},
		exitTeams() {
			this.teamsShown = false;
		},
	},
};
</script>
